// extracted by mini-css-extract-plugin
export default {"contentWrapp":"style_contentWrapp__tzjMi","btnWrapp":"style_btnWrapp__FEOuK","totalAmount":"style_totalAmount__O-xiK","bg_main":"style_bg_main__D0MnM","bg_top":"style_bg_top__L49os"};